<template>
  <section>
    <v-toolbar color="#9190b5" dark prominent src="https://picsum.photos/1920/1080?random">
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top right, rgba(145,144,181,.7), rgba(25,32,72,.7)"></v-img>
      </template>
      <v-toolbar-title>{{ $route.name }}</v-toolbar-title>
      <v-spacer/>
      <template v-slot:extension>
        <v-btn-toggle dense mandatory v-model="view_type"  group color="primary" class="mx-3 box-shadow">
          <v-btn small color="transparent" value="calendar">
            <v-icon>mdi-calendar</v-icon>
          </v-btn>

          <v-btn small color="transparent" value="table">
            <v-icon>mdi-table</v-icon>
          </v-btn>
        </v-btn-toggle>

        <v-btn small color="primary" class="box-shadow" @click="setToday">Today</v-btn>

        <v-spacer/>
        <v-btn text @click="$refs.workingHoursCalendar.prev()">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title class="mx-3">{{ $moment(focus).format('MMMM YYYY') }}</v-toolbar-title>
        <v-btn text @click="$refs.workingHoursCalendar.next()">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>

        <v-spacer/>
        <v-toolbar-items style="height: auto">
          <v-select
              v-model="type"
              :items="type_options"
              item-text="label"
              item-value="value"
              menu-props="auto"
              hide-details
              single-line
              outlined
              dense
          ></v-select>



        </v-toolbar-items>
      </template>
    </v-toolbar>


    <v-container v-show="view_type === 'calendar'" fluid>
      <v-card>
        <v-calendar ref="workingHoursCalendar"
                    :now="today"
                    :type="type"
                    v-model="focus"
                    color="primary"
                    :events="events"
                    :event-color="getEventColor"
                    :event-more="false"
                    :interval-minutes="90"
                    :interval-count="16"
                    :interval-height="40"
                    @click:more="viewMore"
                    @click:date="viewMore"
                    @click:event="openSelectedItemDialog"
                    @change="loadData"
        ></v-calendar>
      </v-card>
    </v-container>

    <v-container v-show="view_type === 'table'" fluid>
      <v-card>
        <v-data-table :headers="table_data.headers"
                      :items="data_items"
                      :search="table_data.search">

          <template v-slot:item.start="{ value }">
            <span class="text-no-wrap">{{ $moment(value).format('DD/MM/YYYY HH:mm') }}</span>
          </template>
          <template v-slot:item.end="{ value }">
            <span class="text-no-wrap">{{ $moment(value).format('DD/MM/YYYY HH:mm') }}</span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn color="primary" small @click="openSelectedItemDialog({event: item})">show</v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <v-dialog max-width="500px" v-model="selected_item_dialog" @click:outside="closeSelectedItemDialog">
      <v-card v-if="selected_item">
        <v-toolbar dense dark color="primary">
          <v-toolbar-title>Settings</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeSelectedItemDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-list-item>
          <v-list-item-action>
            <v-icon>mdi-calendar</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ selected_item.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ selected_item.short_name }}</v-list-item-subtitle>

          </v-list-item-content>

          <v-list-item-action>
            <v-btn small class="box-shadow" color="success" target="_blank"
                   :to="{name: 'Session', params: {session_id: selected_item.session_id}}">
              Open session
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider/>

        <v-list-item>
          <v-list-item-action>
            <v-icon>mdi-timer</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Start {{ $moment(selected_item.start).format('DD MMMM YYYY HH:mm') }}</v-list-item-title>
            <v-list-item-subtitle>UK Time zone</v-list-item-subtitle>
            <v-list-item-subtitle></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider/>
        <v-list-item>
          <v-list-item-action>
            <v-icon>mdi-alarm</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>End {{ $moment(selected_item.end).format('DD MMMM YYYY HH:mm') }}</v-list-item-title>
            <v-list-item-subtitle>UK Time zone</v-list-item-subtitle>
            <v-list-item-subtitle></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider/>

        <!--            <v-list-item :href="selected_item.zoom_meeting_id" target="_blank">-->
        <!--              <v-list-item-action>-->
        <!--                <v-icon>mdi-video</v-icon>-->
        <!--              </v-list-item-action>-->
        <!--              <v-list-item-content>-->
        <!--                <v-list-item-subtitle>Zoom meeting link</v-list-item-subtitle>-->
        <!--                <v-list-item-title>{{ selected_item.zoom_meeting_id }}</v-list-item-title>-->
        <!--              </v-list-item-content>-->
        <!--            </v-list-item>-->
        <!--            <v-divider/>-->

        <v-list-item v-if="selected_item.mock">
          <v-list-item-action>
            <v-icon>mdi-alpha-p-box-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-subtitle>Practice area</v-list-item-subtitle>
            <v-list-item-title>{{ selected_item.mock.practice_area.name }}</v-list-item-title>

          </v-list-item-content>
        </v-list-item>
        <v-divider/>

        <v-list-item v-if="selected_item.mock">
          <v-list-item-action>
            <v-icon>mdi-alpha-s-box-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-subtitle>Session type</v-list-item-subtitle>
            <v-list-item-title>{{ selected_item.mock.session_type.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <template v-if="profile_type && profile_type !== 'aspiringSolicitor' && selected_item.user">
          <v-divider/>
          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-account</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-subtitle>Client name</v-list-item-subtitle>
              <v-list-item-title>{{ selected_item.user.full_name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider/>

          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-account</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-subtitle>Client nickname</v-list-item-subtitle>
              <v-list-item-title>{{ selected_item.user.nickname }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider/>

          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-email</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-subtitle>Client email</v-list-item-subtitle>
              <v-list-item-title>{{ selected_item.user.email }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider/>

          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-skype</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-subtitle>Client skype</v-list-item-subtitle>
              <v-list-item-title>{{ selected_item.user.skype }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-divider/>
        <v-card-actions class="justify-space-between">
          <v-btn block color="primary" :to="{name: 'Session', params: {session_id: selected_item.session_id}}">
            Open session
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import {mapGetters} from "vuex";
export default {
  data: () => ({
    view_type: 'calendar',
    view_type_opts: [
      { value: 'calendar', label: 'Calendar'},
      { value: 'table', label: 'Table'},
    ],
    study_groups: [],
    load_options: null,
    type: 'month',
    type_options: [
      { value: 'month', label: 'Month'},
      { value: 'week', label: 'Week'},
      { value: 'day', label: 'Day'},
    ],
    today: '',
    focus: '',
    data_items: [],
    table_data: {
      headers: [
        { text: 'Tutor', value: 'tutor.nickname' },
        { text: 'User', value: 'user.full_name' },
        { text: 'Practice area', value: 'mock.practice_area.short_name' },
        { text: 'Session type', value: 'mock.session_type.short_name' },
        // { text: 'MeetingID', value: 'zoom_meeting_id' },
        // { text: 'AN/SA', value: 'include_an' },
        { text: 'Date', value: 'start' },
        { text: 'End', value: 'end' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      search: ''
    },
    create_item_dialog: false,
    selected_item: null,
    selected_item_dialog: false,
    api_errors: []
  }),
  computed: {
    ...mapGetters({profile_type: 'getAuthUserProfileType'}),
    events: function () {
      let items = []

      if(this.study_groups && this.study_groups.length > 0) {
        let study_groups_events = this.study_groups
            .filter(item => item.study_period && item.study_period.length > 0)
            .map(item => ({
              ...item,
              start: item.study_period[0],
              end: item.study_period[1],
              disabled: true
            }))

        items.push(...study_groups_events)

        this.study_groups.forEach(study_group => {
          study_group.study_sub_groups.forEach(study_sub_group => {
            study_sub_group.p1_exam_dates.forEach(item => {
              items.push({
                name: study_group.short_name+' P1 exam',
                color: 'error',
                start: item,
                end: item,
                disabled: true
              })
            })

            study_sub_group.p2_exam_dates.forEach(item => {
              items.push({
                name: study_group.short_name+' P2 exam',
                color: 'error',
                start: item,
                end: item,
                disabled: true
              })
            })
          })
        })
      }

      if(this.data_items && this.data_items.length > 0) {
        let mapped_items = this.data_items.map(item => ({...item, name: item.short_name}))
        items.push(...mapped_items)
      }
      return items
    }
  },
  created() {
    this.today = this.$currentTime().format('YYYY-MM-DD')
    this.focus = this.$currentTime().format('YYYY-MM-DD')
    this.loadStudyGroups()
  },
  methods: {
    async loadData({start, end}) {
      this.load_options = {start, end}
      this.data_items = await this.axios.get(`api/events`, {
        params:{date_from: start.date, date_to: end.date}
      })
          .then(({data}) => data.data)
    },
    async loadStudyGroups() {
      this.study_groups = await this.axios.get(`api/study-groups`)
          .then(({data}) => data.data)

      this.study_groups = this.study_groups.map(item => ({...item, color: '#'+Math.floor(Math.random()*16777215).toString(16)}))
    },
    setToday() {
      this.today = this.$currentTime().format('YYYY-MM-DD')
      this.focus = this.$currentTime().format('YYYY-MM-DD')
    },
    viewMore({date}) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor(event) {
      if(event.color) return event.color
      let diff = this.$moment(event.end).diff(this.$currentTime().format())
      return diff > 0 ? 'primary' : 'secondary'
    },
    openSelectedItemDialog({event}) {
      if(event.disabled) return ;
      this.selected_item = event
      this.selected_item_dialog = true
    },
    closeSelectedItemDialog() {
      this.selected_item_dialog = false
      this.selected_item = null
    },
  }
}
</script>